/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-else-return */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-lonely-if */
/* eslint-disable no-unused-expressions */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-nested-ternary */
import { Container } from '@mui/material'
import Button from 'components/Button/Index'
import FaqDialog from 'components/FAQdialog/Index'
import OrderDiffAlertDialog from 'components/OrderDiffAlertDialog/Index'
import PosPaidAlertDialog from 'components/PosPaidAlertDialog/Index'
import { tabData, tabDetail } from 'features/tab/tab'
import { faqUrlData, paymentEnableData } from 'features/restaurant/restaurant'
import { menuList } from 'features/menu/menu'
import { IFaqUrlResponse } from 'interfaces/common'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

interface props {
  remainingAmount?: number
  isYourTabTitle?: boolean
  isViewMenuTitle?: boolean
  isItemSelected?: boolean
  isHideFooter?: boolean
}

function PayNowFooter({
  remainingAmount,
  isYourTabTitle = false,
  isViewMenuTitle = false,
  isItemSelected = false,
  isHideFooter = false,
}: props) {
  const navigate = useNavigate()
  const tabDetailData = useSelector(tabData)
  const tabDetails = useSelector(tabDetail)
  const faqUrlFromRedux = useSelector(faqUrlData)
  const menus = useSelector(menuList)
  const isPaymentEnable = useSelector(paymentEnableData)
  const [faqUrl, setFaqUrl] = useState<IFaqUrlResponse>(faqUrlFromRedux)
  const [faqDialog, setOpenFaqDialog] = useState(false)
  const [url, setUrl] = useState('')
  const [orderWithStatus, setOrderWithStatus] = useState([])
  const [openAlertDialog, setOpenALertDialog] = useState(false)
  const [openOrderDiffAlertDialog, setOpenOrderDiffALertDialog] =
    useState(false)

  // Check if menus are available
  const hasMenus = menus && menus.length > 0

  useEffect(() => {
    const paidOders = []
    tabDetails?.orders.forEach((element) => {
      const paid = element.items.every((x) => x.isPaid)
      paidOders.push({
        id: element.orderId,
        isSelected: element.isSelected,
        isFullPaid: paid,
      })
    })
    setOrderWithStatus(paidOders)
  }, [tabDetails?.orders])

  const isCheckSelected = tabDetails?.orders?.every(
    (x) => x.isSelected !== false
  )
  const isCheckselectedSelected = tabDetails?.orders
    ?.filter((d) => d.items.some((y) => !y.isPaid))
    .some((x) => x.isSelected === true)

  const isCheckUnselectedSelected = tabDetails?.orders?.some(
    (x) => x.isSelected === false
  )

  const isCheckSelectedPaid = orderWithStatus.some(
    (x) => x.isSelected && !x.isFullPaid
  )

  useEffect(() => {
    if (faqUrlFromRedux) {
      setFaqUrl(faqUrlFromRedux)
    }
  }, [faqUrlFromRedux])

  // Preloading is now handled in App.tsx

  const buttonTitle = () => {
    return 'Pay Your Tab'
  }

  return (
    <>
      <footer
        className={`footer mui-fixed ${isHideFooter ? 'hide-footer' : ''}`}
      >
        <Container maxWidth="md">
          <br />

          <>
            {isYourTabTitle && (
              <Button
                id="checkoutButton"
                isTypeLink
                title="Pay Your Tab"
                to="/your-tab"
                linkState={{
                  establishmentId: tabDetailData.establishmentId,
                  isFromSplit: true,
                }}
                color="primary"
                variant="contained"
                disabled={
                  remainingAmount === 0 ||
                  (!isItemSelected &&
                    !isCheckSelected &&
                    tabDetails?.isCheckChanged) ||
                  (isCheckUnselectedSelected && !isCheckselectedSelected) ||
                  !isCheckSelectedPaid
                }
              >
                <span>Pay Your Tab</span>
              </Button>
            )}
            {/* Only show View Menu button if menus are available */}
            {isViewMenuTitle && hasMenus && (
              <Button
                id="checkoutButton"
                isTypeLink
                title="View Menu"
                to="/view-menu"
                linkState={{ establishmentId: tabDetailData.establishmentId }}
                color="primary"
                variant="contained"
              >
                <span>View Menu</span>
              </Button>
            )}
            {!isYourTabTitle && !isViewMenuTitle && (
              <Button
                id="checkoutButton"
                color="primary"
                variant="contained"
                title={buttonTitle()}
                onClick={() => {
                  // Check health status before navigating to payment
                  const isUnhealthy =
                    !isPaymentEnable?.status ||
                    isPaymentEnable?.isTableDisable ||
                    !isPaymentEnable?.isHealthy

                  if (isUnhealthy) {
                    console.log(
                      'PayNowFooter: Health status is unhealthy, staying on current page',
                      {
                        status: isPaymentEnable?.status,
                        isTableDisable: isPaymentEnable?.isTableDisable,
                        isHealthy: isPaymentEnable?.isHealthy,
                      }
                    )
                    // Force page refresh to show updated status
                    window.location.reload()
                    return
                  }

                  navigate('/payment', { state: { tabDetails } })
                }}
                disabled={
                  remainingAmount === 0 ||
                  (!isItemSelected &&
                    !isCheckSelected &&
                    tabDetails?.isCheckChanged) ||
                  (isCheckUnselectedSelected && !isCheckselectedSelected) ||
                  !isCheckSelectedPaid
                }
              >
                <span>{buttonTitle()}</span>
              </Button>
            )}
          </>
        </Container>
      </footer>
      <FaqDialog
        open={faqDialog}
        url={url}
        onClose={() => setOpenFaqDialog(false)}
      />
      <OrderDiffAlertDialog
        open={openOrderDiffAlertDialog}
        onClose={() => setOpenOrderDiffALertDialog(false)}
      />
      <PosPaidAlertDialog
        open={openAlertDialog}
        onClose={() => setOpenALertDialog(false)}
      />
    </>
  )
}

export default PayNowFooter
